/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {collection, deleteDoc, doc, getDocs} from "firebase/firestore";
import {db} from "../../../firebase/firebase";

const Lista_Prueba = () => {

    const {sCell} = useResponsive();
    const [blogs, setBlogs] = useState([]);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [mensajeExito, setMensajeExito] = useState('');

    const handleEliminar = async (id, titulo) => {
        const confirmar = window.confirm(`¿Estás seguro de que deseas eliminar el proyecto "${titulo}"?`);
        if (!confirmar) return;

        try {
            await deleteDoc(doc(db, "proyectos", id));
            setBlogs(prev => prev.filter(proyecto => proyecto.id !== id));

            // Mostrar Snackbar
            setMensajeExito(`Proyecto "${titulo}" eliminado con éxito.`);
            setOpenSnackbar(true);
        } catch (error) {
            console.error("Error al eliminar el proyecto:", error);
        }
    };


    useEffect(() => {
        const fetchProyectos = async () => {
            const querySnapshot = await getDocs(collection(db, 'blogs'));
            const docs = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setBlogs(docs);
        };

        fetchProyectos();
    }, []);

    if (blogs.length === 0) return <Typography>Cargando blogs...</Typography>;


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 10}} sx={{pt: 20,}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{maxWidth: 1400, px: 3}}>
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid container size={{xs: 12, sm: 6, md: 6}}>
                        <Typography>Blog</Typography>
                    </Grid>

                    <Grid container
                          justifyContent="flex-end"
                          alignItems="center"
                          size={{xs: 12, sm: 6, md: 6}}>
                        <Button href={'/dashboard/blogs/crear'}>
                            Crear
                        </Button>
                    </Grid>
                </Grid>
                <Grid container
                      justifyContent={'flex-start'}
                      alignItems={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}} sx={{}}>

                    {blogs.map((item, index) => (
                        <Grid container
                              justifyContent={'flex-start'}
                              alignItems={'flex-start'}
                              key={item.id}
                              size={{xs: 12, sm: 12, md: 12}}>
                            <Grid container spacing={2} size={{xs: 12, sm: 12, md: 12}}
                                  sx={{borderBottom: '1px solid #ccc', py: 1}}>
                                <Grid container size={{xs: 12, sm: 12, md: 7}}>
                                    <Typography>
                                        {item.titulo}
                                    </Typography>
                                </Grid>
                                <Grid container
                                      justifyContent={'flex-end'}
                                      alignItems={'flex-start'}
                                      size={{xs: 12, sm: 5, md: 5}}>
                                    <Button href={`/dashboard/blogs/${item.id}`}>
                                        Editar
                                    </Button>
                                    <Button  onClick={() => handleEliminar(item.id, item.titulo)}>
                                        Eliminar
                                    </Button>
                                </Grid>

                            </Grid>
                        </Grid>
                    ))}

                </Grid>



            </Grid>


        </Grid>
    )


}
export default Lista_Prueba;

//
// <Grid
//     container
//     justifyContent={'center'}
//     alignItems={'flex-start'}
//     size={{xs: 12, sm: 12, md: 12}}>
//
//     <Grid container
//           justifyContent={'center'}
//           alignItems={'flex-start'}
//           size={{xs: 12, sm: 12, md: 12}}
//           sx={{pt: 20, ml: 10, maxWidth: 1400, px: 3}}>
//
//
//         <Grid container
//               size={{xs: 12, sm: 6, md: 6}}>
//             <Typography>Blog</Typography>
//         </Grid>
//
//         <Grid container
//               justifyContent="flex-end"
//               alignItems="center"
//               size={{xs: 12, sm: 6, md: 6}}>
//             <Button href={'/dashboard/blogs/crear'}>
//                 Crear
//             </Button>
//         </Grid>
//
//     </Grid>
//
//
// </Grid>